import { useQuery, ApolloClient } from '@apollo/client';
import {
    CHECK_SAME_AREA_ENABLED,
    CheckSameAreaEnabledResponse,
    IS_OPEN_DSP_SCAN_GRAY
} from 'pages/delivery/graphql/queries/checkSameAreaEnabled';
import { client } from '../graphql/client';

/**
 * 灰度功能相关的工具函数
 */

/**
 * 检查是否启用同区域校验功能（灰度功能）
 * @returns {object} { data, loading, error } - 查询结果
 */
/*const useCheckSameAreaEnabled = () => {
    return useQuery<CheckSameAreaEnabledResponse>(
        CHECK_SAME_AREA_ENABLED,
        {
            fetchPolicy: 'network-only'
        }
    );
};

/!**
 * 判断是否使用新版本功能 (Hook方式)
 * @returns boolean - true表示使用新功能，false表示使用旧功能
 *!/
export const shouldUseNewFeature = (): boolean => {
    const { data: sameAreaEnabledData } = useCheckSameAreaEnabled();
    return sameAreaEnabledData?.checkSameAreaEnabled === true;
};*/

/**
 * 判断是否使用新版本功能 (直接调用接口方式)
 * @returns Promise<boolean> - true表示使用新功能，false表示使用旧功能
 */
export const checkSameAreaEnabled = async (): Promise<boolean> => {
    try {
        const result = await client.query({
            query: IS_OPEN_DSP_SCAN_GRAY,
            fetchPolicy: 'network-only'
        });
        return result.data.isOpenDspScanGray === true;
    } catch (error) {
        console.error('Failed to check same area enabled:', error);
        return false;
    }
};